import Alpine from "alpinejs";

export default function () {
    document.addEventListener('alpine:init', () => {
        Alpine.data('MotocampRegistrationForm', () => {
            const pricing = {
                poprve: 5000,
                turnus: {
                    organizovane: 49000,
                    skupinove: 46000,
                    pronajem: 0,
                },
                spolujezdec: 26000,
                klient: -5000,
                motoskola: 6500,
                doprava: -5000,
                zavazadlo: 2000,
                ubytovani: 3500
            }

            return {
                step: 1,
                ponekolikate: undefined,
                typ: undefined,
                turnus: '',
                klient: undefined,
                motoskola: undefined,
                doprava: undefined,
                zavazadlo: undefined,
                ubytovani: undefined,
                spolubydlici: undefined,
                stejnaAdresa: false,

                tryGoingToNextStep() {
                    let valid = true;
                    let invalidInput = null;

                    const inputs = this.$el.closest('form').querySelectorAll('fieldset.AppForm-inner > div.FormSection:not([data-last-step]) :where(input, select)');
                    Array.from(inputs).forEach((input: HTMLInputElement) => {
                        if (invalidInput || input.checkValidity()) return;

                        valid = false;
                        invalidInput = input;
                    });

                    (valid && !invalidInput) ? ((this.step = 2) && document.querySelector('h1').scrollIntoView()) : invalidInput.reportValidity();
                },

                init() {
                    this.$watch('ponekolikate', () => !['1','2','3','4','6'].includes(this.turnus) && (this.turnus = ''))
                    this.$watch('motoskola', () => this.motoskola === 'ano' && (this.doprava = 'ne'))
                },

                get isRnR() {
                    return ['5'].includes(this.turnus)
                },

                get getTurnusName() {
                    switch (this.turnus) {
                        case '1': return '16.1. - 20.1.2026 | Organizovaná výjižďka s guidy';
                        case '2': return '23.1. - 27.1.2026 | Organizovaná výjižďka s guidy';
                        case '6': return '6.2. - 10.2.2026 | Organizovaná výjižďka s guidy';
                        case '3': return '16.1. - 20.1.2026 | Organizovaná výjižďka s guidy - skupina TULÁCI';
                        case '4': return '23.1. - 27.1.2026 | Organizovaná výjižďka s guidy - skupina TULÁCI';
                        case '5': return '28.1. - 10.2.2026 | RENT and RIDE – délka trvání dle tvé volby';
                    }
                },

                get price() {
                    let price = 0;

                    if (this.turnus !== '' && this.typ === 'řidič') {
                        if (['1','2','6'].includes(this.turnus)) {
                            price += pricing.turnus.organizovane;

                            if (this.klient === 'ano') {
                                price += pricing.klient;
                            }
                        } else if (['3','4'].includes(this.turnus)) {
                            price += pricing.turnus.skupinove;

                            if (this.ponekolikate === 'ne') {
                                price += pricing.poprve;
                            }
                        } else if (['5'].includes(this.turnus)) {
                            price += pricing.turnus.pronajem;
                        }
                    } else if (this.typ === 'spolujezdec') {
                        price = pricing.spolujezdec;
                    }

                    if (this.motoskola === 'ano') {
                        price += pricing.motoskola;
                    }

                    if (this.doprava === 'ne') {
                        price += pricing.doprava;

                        if (this.zavazadlo === 'letadlo') {
                            price += pricing.zavazadlo;
                        }
                    }

                    if (this.ubytovani === 'samostatne') {
                        price += pricing.ubytovani;
                    }

                    return Math.max(0, price);
                },
            }
        });
    });

    document.addEventListener("DOMContentLoaded", () => {
        window.hasOwnProperty('html_forms') && html_forms?.on('success', (formElement: HTMLFormElement) => {
            if (!formElement || formElement.dataset.slug !== 'motocamp-registration') return;
            document.querySelector('section.PageHeader').scrollIntoView();
        });
    });
}